import { fetchScrubShipmentsList } from "../api/ScrubListAPI";

export const initialState = {
    items: [],
    loading: false,
    selectedItems: []
};

export const ScrubListReducer = (state, action) => {
    switch (action.type) {
        case "LOAD_DATA":
            const {targetUseCase, missingViewNewStrategyEnabled, dispatcher} = action.data;
            fetchScrubShipmentsList({targetUseCase}, {missingViewNewStrategyEnabled}, dispatcher)
            return {...initialState, loading: true}
        case "SET_DATA":
            return { ...state, items: action.data, loading: false }
        case "SET_LOADING":
            const {loadingValue} = action.data;
            return { ...state, loading: loadingValue }
        case "SET_SELECTED":
            return { ...state, selectedItems: action.data }
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/commons/reducer/ScrubListReducer.js